import { faCog, faHome, faTh } from "@fortawesome/free-solid-svg-icons";

export const paths = [
    {
        url: '/',
        icon: faHome,
        title: 'Dashboard'
    },
    {
        url: '/media',
        icon: faTh,
        title: 'Media'
    },
    {
        url: '/pages',
        icon: faCog,
        title: 'Pages'
    },
]